import { getUtc } from '@shared/functions/get-utc.function';

export function getDateObjectFunction(date: Date | string): Date {
  return date ? getUtc(date) : null;
}
